import { Transition, Variants, motion } from 'motion/react';
import { ReactNode } from 'react';

import { cn } from '@/utils/style-utils.ts';

interface Props {
    className?: string;
    children: ReactNode;
    fullScreen?: boolean;
}

// Define your combined fade and slide animation variants
const slideVariants: Variants = {
    initial: { opacity: 0, y: 25 }, // Start slightly below and transparent
    in: { opacity: 1, y: 0 }, // Fade in and move to original position
    out: { opacity: 0, y: 25 }, // Fade out and move downward
};

const slideTransition: Transition = {
    duration: 0.3, // Adjust the duration as needed
};

export const Page = ({ children, className, fullScreen = false }: Props) => {
    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={slideVariants}
            transition={slideTransition}
            className={cn('flex flex-col items-center', fullScreen ? 'h-screen w-screen' : 'h-full w-full', className)}
        >
            {children}
        </motion.div>
    );
};
